import React from 'react';
import { connect } from 'react-redux';

import { createComponent } from 'console-kit';

import _enums from '../../../common/enums';

import AuthPanelSelectors from '../redux/selectors';

import AuthPanelForm from './content/AuthPanelForm';
import AuthPanelCESUpgradeMessage from './content/AuthPanelCESUpgradeMessage';

const AuthPanel = createComponent({
  displayName:  'AuthPanel',

  render(props) {
    return (
      <React.Fragment>
        <Choose>
          <When condition={[_enums.loginTypes.CESSSO_TYPE, _enums.loginTypes.CESSSO_INVITED_TYPE].includes(props.loginType)}>
            <AuthPanelCESUpgradeMessage />
          </When>

          <Otherwise>
            <AuthPanelForm />
          </Otherwise>
        </Choose>
      </React.Fragment>
    );
  },
});

export default connect(
  state => ({
    loginType: AuthPanelSelectors.loginType(state),
  }),
)(AuthPanel);
